import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { fmtDT } from "./trialUi";

const CATS = [["obligatoire", "1. Obligatoire", "text-red-300"], ["recommande", "2. Recommandé", "text-amber-300"], ["avance", "3. Avancé", "text-sky-300"]];

export function IntegrationChecklist({ dossier, cfg, onChanged }) {
  const [busy, setBusy] = useState(null);
  const ck = dossier.checklist || {};
  const toggle = async (key, done) => {
    setBusy(key);
    try { await api.post(`/trial-integration/dossiers/${dossier.id}/checklist/${key}`, { completed: done }); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Échec"); }
    setBusy(null);
  };
  const verify = async () => {
    if (!window.confirm(`Vérifier et fermer le dossier d'intégration de ${dossier.full_name} ?\nVotre nom et la date/heure seront enregistrés.`)) return;
    try { await api.post(`/trial-integration/dossiers/${dossier.id}/verify`); toast.success("Dossier vérifié — Intégration complétée ✓"); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Étapes obligatoires manquantes"); }
  };
  const pct = (cat) => { const items = cfg.checklist[cat]; const d = items.filter((i) => ck[i.key]?.completed).length; return [d, items.length]; };

  return (
    <div className="space-y-4" data-testid="ti-checklist">
      <div className="flex gap-1.5">
        {CATS.map(([cat, lbl, tone]) => { const [d, t] = pct(cat); return (
          <div key={cat} className="flex-1">
            <div className={`text-[10px] font-bold ${tone} mb-1`}>{lbl} {d}/{t}</div>
            <div className="h-1.5 rounded-full bg-zinc-800 overflow-hidden"><div className={`h-full ${cat === "obligatoire" ? "bg-red-500" : cat === "recommande" ? "bg-amber-500" : "bg-sky-500"}`} style={{ width: `${t ? d / t * 100 : 0}%` }} /></div>
          </div>); })}
      </div>
      {CATS.map(([cat, lbl, tone]) => (
        <div key={cat} className="rounded-xl border border-zinc-800 p-3" data-testid={`ti-checklist-${cat}`}>
          <div className={`text-xs font-bold ${tone} mb-2`}>{lbl}</div>
          <div className="space-y-1">
            {cfg.checklist[cat].map((it) => { const v = ck[it.key] || {}; return (
              <label key={it.key} className="flex items-start gap-2 text-xs text-zinc-200 py-1 cursor-pointer" data-testid={`ti-item-${it.key}`}>
                <input type="checkbox" checked={!!v.completed} disabled={busy === it.key} onChange={(e) => toggle(it.key, e.target.checked)} className="mt-0.5 accent-amber-500" />
                <span className={v.completed ? "line-through text-zinc-500" : ""}>{it.label}
                  {v.completed && <span className="block text-[10px] text-zinc-600 no-underline">{v.completed_by?.name} · {fmtDT(v.completed_at)}{v.notes ? ` · ${v.notes}` : ""}</span>}</span>
              </label>); })}
          </div>
        </div>
      ))}
      {dossier.verified_at ? (
        <div className="rounded-xl border border-emerald-600 bg-emerald-950/40 p-3 flex items-center gap-2 text-sm text-emerald-200" data-testid="ti-verified-badge">
          <ShieldCheck className="w-5 h-5" /> Vérifié par coach/admin — {dossier.verified_by?.name} · {fmtDT(dossier.verified_at)}</div>
      ) : (
        <button onClick={verify} disabled={!dossier.can_verify} data-testid="ti-verify-btn"
          className="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white font-bold py-2.5 rounded-lg text-sm">
          <ShieldCheck className="w-4 h-4" /> Vérifier et fermer le dossier ({dossier.mandatory_done}/{dossier.mandatory_total} obligatoires)</button>
      )}
    </div>
  );
}
